module.exports = __webpack_public_path__ + "media/images/pages/lachrls_bg-13ab414a7e9ef15088dc19811859d8ab.jpg";